module.exports = {
  // languages enabled in the language selector     it: 'language.italian',
  enabledLanguages: {
    'en-US': 'language.english',
    de: 'language.german',
    es: 'language.spanish',
    fr: 'language.french',
    jp: 'language.japanese',
    pt: 'language.portuguese',
    it: 'language.italian',
  },
  displayLanguageSelector: true,
  defaultLangKey: 'en-US',
};
